module.exports = __webpack_public_path__ + "static/media/tick_1.5ae445fa.svg";